import { render, staticRenderFns } from "./bargain.vue?vue&type=template&id=31aa04f8&scoped=true"
import script from "./bargain.vue?vue&type=script&lang=js"
export * from "./bargain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31aa04f8",
  null
  
)

export default component.exports